var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center bg-soft-light",style:({
    height: _vm.height,
    width: _vm.width,
    color: '#CECECE'
  })},[_c('i',{staticClass:"far fa-image font-size-18"}),_c('small',{staticClass:"my-2"},[_vm._v("No Image")])])}
var staticRenderFns = []

export { render, staticRenderFns }